export default __webpack_public_path__ + "static/media/streamer_avatar5.1afa851e.png";